module.exports = __webpack_public_path__ + "img/avatar.ee9b466b.png";